import React, { useState, useRef, useEffect, Fragment } from 'react';
import moment from 'moment';
import { connect, useSelector, useDispatch } from 'react-redux';
import { injectIntl, useIntl } from 'react-intl';

//components/controls
import Table, { Column } from 'Components/Table';
import { ModalBody, ModalFooter } from 'Components/Modal';
import Modal from 'Components/Modal';
import { Grid } from '@mui/material';
import Button from 'Components/Button';
import InputDate from 'Components/InputDate';
import Input from 'Components/Input';
import Checkbox from 'Components/Checkbox';
import Form from 'Components/Form';
import { TagsGroup } from 'Components/Tag';
import Tabs, { TabContainer } from 'Components/Tabs';
import { NotificationManager } from 'Components/Notifications';
import { useInput, useSelect } from 'Core/hooks';
import { PillsGroupSearch } from 'Components/Pill';
import { MenuComponent } from 'Components/Menu';
import { OrderData, MerginObjectArray, DayFormat } from 'Core/data/Helpers';
import './main.scss';

//actions
import {
	saveStarterSchedule,
	searchStarterSchedulesRequest,
	deleteStarterScheduleRequest,
	updateStarterScheduleRequest,
	catalogLoad,
	fleetCloseModalStarterSchedule,
	clearRedux
} from 'Redux/actions';

const initialStateDays = [
	{ name: 'monday', startedEnable: null, startedDisable: null, checked: false },
	{
		name: 'tuesday',
		startedEnable: null,
		startedDisable: null,
		checked: false,
	},
	{
		name: 'wednesday',
		startedEnable: null,
		startedDisable: null,
		checked: false,
	},
	{
		name: 'thursday',
		startedEnable: null,
		startedDisable: null,
		checked: false,
	},
	{ name: 'friday', startedEnable: null, startedDisable: null, checked: false },
	{
		name: 'saturday',
		startedEnable: null,
		startedDisable: null,
		checked: false,
	},
	{ name: 'sunday', startedEnable: null, startedDisable: null, checked: false },
];

const ModalScheduleStarter = (props) => {

	const dispatch = useDispatch()
	const {
		isOpen,
		loadingSearchStarterSchedule,
		createStarterSchedule,
		starterScheduleList,
		deleteStarterSchedule,
		loadingDeleteStarterSchedule,
		updateStarterScheduleResult,
		loadingUpdateStarterSchedule,
		loadingCreateStarterSchedule
	} = useSelector(state => state.vehicleScheduleStarterRedux);
	const unitGroups = useSelector(state => state.catalogsRedux.unitGroups);

	const [vehicleGroupsList, setVehicleGroupsList] = useState([
		{ id: -1, name: 'All', color: '#000' },
	]);

	const { messages } = useIntl();
	const [error, setError] = useState();
	const [days, setDays] = useState(JSON.parse(JSON.stringify(initialStateDays)));
	const selectGroups = useSelect(vehicleGroupsList);
	const [currentTab, setCurrentTab] = useState(0);
	const nameStarterSchedule = useInput('');
	const [editSchedule, setEditSchedule] = useState();
	const [openDelete, setOpenDelete] = useState(false);
	const [currentDelete, setCurrentDelete] = useState();



	const [filters, setFilters] = useState({
		groups: [{ id: -1, name: 'All', color: '#000' }],
		vehicleEvents: [],
		vehicleEventTimes: null
	});

	const menuServiceDetailOptions = [messages['edit'], messages['delete']];

	const frmCreateSchedule = useRef();
	const frmDeleteSchedule = useRef();

	//efects
	useEffect(() => {
		//mount

		//unmount
		return () => {
			dispatch(clearRedux("FLEET_MODAL_SCHEDULE_STARTER"))
		}
	}, [])

	//when open modal
	useEffect(() => {
		if (isOpen) {
			dispatch(searchStarterSchedulesRequest());
			dispatch(catalogLoad(["unitGroups"]));
		}
	}, [isOpen]);

	//function to show notification
	const showNotification = (title, message) => {
		NotificationManager.success(title, message, 3000, null, null, 'success');
	};

	const handleSave = () => {
		searchStarterSchedulesRequest();
		handleChangeTab(1);
	};

	const restarModalInfo = () => {
		setDays(JSON.parse(JSON.stringify(initialStateDays)));
		setError(null);
		setEditSchedule(null);
		nameStarterSchedule.onChange('');
		selectGroups.onChange(null);
	};

	const checkOneDay = (index) => {
		const day = days[index];
		if (day) changeDay(day, 'checked', !day.checked, index);
	};

	const handleTimeChange = (date, key, index) => {
		const day = days[index];
		if (day) changeDay(day, key, date, index);
	};

	const changeDay = (day, key, value, index) => {
		let newDay = {};
		if (key === 'checked' && !value) {
			newDay = {
				...day,
				checked: value,
				startedEnable: null,
				startedDisable: null,
			};
		} else newDay = { ...day, [key]: value };
		const updatedDays = [...days.slice(0, index), newDay, ...days.slice(index + 1)];
		setDays(updatedDays);
	};

	const getIdsGroups = () => {
		return filters
			? filters.groups.map((group) => {
				return group.id;
			}) : [];
	};
	const handleDeleteSubmit = () => {
		if (currentDelete && currentDelete.id) deleteStarterScheduleRequest(currentDelete.id);
	};

	const handleSubmit = () => {
		const validation = validateTimes();
		let groups = [];
		let idsGroups = getIdsGroups();
		idsGroups.map((group) => {
			if (group === -1) {
				vehicleGroupsList.map((item) => {
					groups.push(item.id);
				})
				groups.shift();
			} else groups = getIdsGroups();
		})

		if (!validation.message) {
			let schedule = fillSchedule();
			const payload = {
				id: editSchedule || '',
				name: nameStarterSchedule.value,
				groupIds: groups,
				schedule,
			};
			if (editSchedule) updateStarterScheduleRequest(payload);
			else saveStarterSchedule(payload);

		} else setError(validation.message);
	};

	const fillSchedule = () => {
		let Schedule = {};
		days.forEach((day) => {
			if (day && day.checked) {
				Schedule[day.name] = {
					enableTime: moment(day.startedEnable).format('HH:mm'),
					disableTime: moment(day.startedDisable).format('HH:mm'),
				};
			}
		});
		return Schedule;
	};

	const validateTimes = () => {
		let isChecked = false;
		let message = null;
		for (const item of days) {
			if (item.checked) {
				isChecked = true;
				if (item.startedEnable > item.startedDisable) {
					message = 'Starter Disabled must be greater than Starter Enabled';
				}
			}
		}
		if (!isChecked) message = 'You must select at least one day';
		return {
			message,
		};
	};

	const onClose = () => {
		if (editSchedule)
			handleChangeTab(1);

		restarModalInfo();
		setCurrentTab(0);
		dispatch(fleetCloseModalStarterSchedule())
	};

	const handleChangeTab = (index) => {
		if (index === 1) restarModalInfo();
		setCurrentTab(index);
	};


	const getMinTime = (startedEnable) => {
		if (startedEnable) {
			const minTime = moment(startedEnable).add(1, 'h').format('YYYY-MM-DD HH:mm');
			const newTime = new Date(minTime);
			return newTime;
		}
	};

	const handleCloseDelete = () => {
		setOpenDelete(false);
		setCurrentDelete(null);
	};

	const deleteVehicleSchedule = (vehSchedule) => {
		setCurrentDelete(vehSchedule);
		setOpenDelete(true);
	};

	const setFilter = (name, value) => {
		let newFilters = { ...filters };
		newFilters[name] = value;
		setFilters(newFilters);
	}

	const loadEditSchedules = (schedules) => {
		let newSchedules = JSON.parse(JSON.stringify(initialStateDays));
		if (schedules) {
			Object.keys(schedules).forEach((name, key) => {
				if (schedules[name]) {
					let date = moment().format('YYYY-MM-DD');
					newSchedules[key].name = name;
					newSchedules[key].checked = true;
					newSchedules[key].startedEnable = new Date(`${date} ${schedules[name].enableTime}`);
					newSchedules[key].startedDisable = new Date(`${date} ${schedules[name].disableTime}`);
				}
			});
		}
		return newSchedules;
	};

	const editVehicleSchedule = (schedule) => {
		setEditSchedule(schedule.id);
		setCurrentTab(0);
		nameStarterSchedule.onChange(schedule.name);
		let groupsList = [];
		const { schedule: schedules, groups } = schedule;
		groups && groups.map((item) => { groupsList.push(item) })
		const newSchedule = loadEditSchedules(schedules);
		setDays(newSchedule);
		setFilter("groups", groupsList);
	};

	const handleClickMenu = (type, schedule) => {
		if (type === 'Edit' || type === 'Editar') {
			editVehicleSchedule(schedule)
		} else if (type === 'Delete' || type === 'Eliminar') {
			deleteVehicleSchedule(schedule)
		}
	};

	useEffect(() => {
		if (createStarterSchedule && createStarterSchedule.id) {
			showNotification(
				messages['success'],
				messages['fleetModal_createStarterScheduleSuccess'],
			);
			handleSave();
		}
	}, [createStarterSchedule, loadingCreateStarterSchedule]);


	useEffect(() => {
		if (updateStarterScheduleResult && updateStarterScheduleResult.id) {
			showNotification(
				messages['success'],
				messages['fleetModal_updateStarterScheduleSuccess'],
			);
			handleSave();
		}
	}, [updateStarterScheduleResult]);

	useEffect(() => {
		if (deleteStarterSchedule) {
			showNotification(
				messages['success'],
				messages['fleetModal_deleteStarterSchuduleSuccess'],
			);
			searchStarterSchedulesRequest();
			setOpenDelete(false);
			setCurrentDelete(null);
		}
	}, [deleteStarterSchedule]);

	useEffect(() => {
		if (unitGroups.length > 0) {
			let newVehicleGroups = [];
			unitGroups.map((unit) => { newVehicleGroups.push(unit) })
			const mergeVehicleGroups = MerginObjectArray(vehicleGroupsList, OrderData(newVehicleGroups, 'name'), "name")
			setVehicleGroupsList(mergeVehicleGroups)
		}
	}, [unitGroups])

	return (
		<Fragment>
			<Modal
				open={isOpen || false}
				handleClose={onClose}
				title={messages['fleetModal_title']}
				position="right"
				size="small"
				loading={loadingCreateStarterSchedule || loadingSearchStarterSchedule || loadingDeleteStarterSchedule || loadingUpdateStarterSchedule}
				header={false}
			>
				<ModalBody>
					<div className="paddingBodyModal">
						<div style={{ marginBottom: "10px" }}>
							<span className="modal-title" style={{ padding: "16px 0px 16px 38px" }}>{messages["fleetView_ScheduledGroupStarter"]}</span>
							<Grid
								container
								justifyContent={'center'}
								direction={'column'}
							>
								<Grid item>
									<Tabs tab={currentTab} pill onChange={handleChangeTab}>
										<TabContainer
											label={
												editSchedule
													? messages['fleetModal_tabUpdate']
													: messages['fleetModal_tabNew']
											}
											index={0}
											style={{ padding: "0 35px", height: 'calc(80vh - 0px)' }}
										>
											<Form ref={frmCreateSchedule} onValidSubmit={handleSubmit}>
												<Grid container justifyContent={'center'} direction={'column'} >
													<Grid item style={{ marginTop: 20 }}>
														<PillsGroupSearch
															label={messages['fleetModal_vehicleGroup']}
															options={vehicleGroupsList}
															value={filters.groups}
															onChange={(items) => setFilter('groups', items)}
															textField="name"
															colorField="default"
															multiple
															removeMargin
														/>
													</Grid>
													<Grid item>
														<Input
															id="fleetModalScheduleStarterName"
															{...nameStarterSchedule}
															type="text"
															label={messages['fleetModal_newStarterScheduleName']}
															placeholder={messages['fleetModal_schedulePlaceholder']}
															requiredMessage={messages['required_field']}
															autoFocus
															maxLength={30}
															required
														/>
													</Grid>
													<Grid item style={{ marginTop: 20 }}>
														{error && (
															<Grid
																container
																spacing={1}
																direction="row"
																justifyContent="flex-start"
																alignItems="flex-start"
																style={{ marginTop: 10 }}
															>
																<Grid item style={{ width: '100%', textAlign: 'center' }}>
																	<span
																		className="text-danger"
																		style={{
																			fontWeight: 700,
																			fontSize: 15,
																		}}
																	>
																		{error}
																	</span>
																</Grid>
															</Grid>
														)}

														<Grid container item>
															<Grid item sm={12}>
																<Grid
																	item
																	container
																	alignItems={'flex-start'}
																	justifyContent={'flex-start'}
																	sm={12}
																>
																	<Grid
																		item
																		container
																		alignItems={'center'}
																		justifyContent={'flex-end'}
																		sm={1}
																	/>
																	<Grid item sm={5}>
																		<label style={{ paddingLeft: 10 }}>
																			{messages['fleetModal_starterEnabledLabel']}
																		</label>
																	</Grid>
																	<Grid item sm={5}>
																		<label style={{ paddingLeft: 10 }}>
																			{messages['fleetModal_starterDisabledLabel']}
																		</label>
																	</Grid>
																</Grid>
																{days.map((day, key) => {
																	let name = DayFormat(day.name);
																	return (
																		<Grid
																			item
																			container
																			alignItems={'flex-start'}
																			justifyContent={'flex-start'}
																			sm={12}
																			key={key}
																		>
																			<Grid
																				item
																				container
																				alignItems={'center'}
																				sm={1}
																			>
																				<label className="labelDateName">{name}</label>
																			</Grid>
																			<Grid item sm={5}>
																				<div style={{ padding: "0 10px" }}>
																					<InputDate
																						id="dateInit"
																						placeholder={messages['fleetModal_time']}
																						type="time"
																						value={day.startedEnable}
																						onChange={(date) => {
																							handleTimeChange(date, 'startedEnable', key);
																						}}
																						timeIntervals="60"
																						required={day.checked}
																						disabled={!day.checked}
																						requiredMessage={messages['fleetModal_fieldRequired']}
																						iconType="unfold_more"
																					/>
																				</div>
																			</Grid>
																			<Grid item sm={5}>
																				<div style={{ padding: "0 10px" }}>
																					<InputDate
																						id="dateInit"
																						placeholder={messages['fleetModal_time']}
																						min={getMinTime(day.startedEnable)}
																						minMessage= {messages['fleetModal_starterDisabledBeGreater']}																					type="time"
																						value={day.startedDisable}
																						onChange={(date) => {
																							handleTimeChange(date, 'startedDisable', key);
																						}}
																						timeIntervals="60"
																						required={day.checked}
																						disabled={!!(!day.checked || !day.startedEnable)}
																						requiredMessage={messages['fleetModal_fieldRequired']}
																						iconType="unfold_more"
																					/>
																				</div>
																			</Grid>
																			<Grid item sm={1} className="contentChecksDays" style={{ paddingLeft: 13 }}>
																				<Checkbox
																					id="checkbox"
																					color="default"
																					className="checkbox-black"
																					indeterminate={true}
																					checked={day.checked}
																					value={day.checked}
																					onChange={() => {
																						checkOneDay(key);
																					}}
																					inputProps={{
																						'aria-label': 'Select Day',
																					}}
																				/>
																			</Grid>
																		</Grid>
																	);
																})}
															</Grid>
														</Grid>

													</Grid>
												</Grid>
											</Form>
										</TabContainer>

										<TabContainer label={messages["fleetModal_schedule"]} index={1} style={{ padding: 0 }}>
											<Table
												data={starterScheduleList}
												rowsPerPage={20}
												hideSelectableCheckbox={true}
												style={{ padding: "0 35px" }}
												hidePagination
											>
												<Column label={messages['fleetModal_tableName']} field="name">
													{(vehicleSchedule) => {
														return (
															<div style={{ width: "145px" }}>
																<Grid
																	container
																	alignItems={'center'}
																	justifyContent={'space-between'}
																	className={'containerTitleMenu'}
																>
																	<Grid item>
																		<span>{vehicleSchedule.name && vehicleSchedule.name.substr(0, 11)}{vehicleSchedule.name && vehicleSchedule.name.length > 11 && "..."}</span>
																	</Grid>
																	<Grid item>
																		<MenuComponent
																			options={menuServiceDetailOptions}
																			icon={'more_vert'}
																			className="icon-menu-vehicle-service showInHover"
																			onClick={(type) => { handleClickMenu(type, vehicleSchedule) }}
																			value={vehicleSchedule}
																		/>
																	</Grid>
																</Grid>
															</div>
														);
													}}
												</Column>
												<Column label={messages['fleetModal_tableDetail']} field="name"

												>
													{(vehicleSchedule) => {
														let desc = [];
														//delete vehicleSchedule.schedule['__typename'];
														Object.keys(vehicleSchedule.schedule).map((key) => {
															const item = vehicleSchedule.schedule[key];
															if (item) {
																desc.push([
																	<div key={key}>
																		{`${key} ${item.enableTime
																			? moment(item.enableTime, 'HH:mm').format('hh:mm A')
																			: ''
																			} - ${item.disableTime
																				? moment(item.disableTime, 'HH:mm').format('hh:mm A')
																				: ''
																			}`}
																	</div>,
																]);
															}
														});
														return desc;
													}}
												</Column>
												<Column label={messages['fleetModal_tableGroups']}
													customValue={(vehicleSchedule) => {
														if (!vehicleSchedule.groupIds) {
															return "";
														}
														return vehicleSchedule.groupIds.length;
													}}
												>
													{(vehicleSchedule) => {
														return (
															<TagsGroup
																options={vehicleSchedule.groups || []}
																nameField="name"
																colorField="color"
															/>
														);
													}}
												</Column>
											</Table>
										</TabContainer>
									</Tabs>
								</Grid>
							</Grid>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button
						id={'btn-cancel-vehicle'}
						type="button"
						onClick={onClose}
						className="btn-cancel"
					>
						{messages["fleetModal_cancel"]}
					</Button>
					{currentTab === 0 && (
						<Button
							id={'btn-schedule'}
							type="button"
							onClick={(e) => {
								e.preventDefault();
								frmCreateSchedule.current.submit();
							}}
							className="btn-blue"
							disabled={loadingSearchStarterSchedule}
						>
							{editSchedule
								? messages['fleetModal_tabUpdate']
								: messages['fleetModal_save']}
						</Button>
					)}
				</ModalFooter>
			</Modal>

			<Modal
				size={'small'}
				open={openDelete}
				handleClose={handleCloseDelete}
				title={`${messages['fleetModal_delete']} "${currentDelete && currentDelete.name}"`}
			>
				<ModalBody>
					<div style={{ padding: '0px 25px' }}>
						<Form ref={frmDeleteSchedule} onValidSubmit={handleDeleteSubmit}>
							<p style={{ overflowWrap: 'anywhere' }}>
								{messages['fleetModal_deleteConfirmation']}
							</p>
						</Form>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button
						id={'btn-cancel-vehicle'}
						type="button"
						onClick={handleCloseDelete}
						className="btn-cancel"
					>
						{messages['fleetModal_cancel']}
					</Button>
					<Button
						id={'btn-schedule'}
						type="button"
						onClick={(e) => {
							e.preventDefault();
							frmDeleteSchedule.current.submit();
						}}
						className="btn-red"
						disabled={loadingSearchStarterSchedule}
					>
						{messages['fleetModal_deleteBtn']}
					</Button>
				</ModalFooter>
			</Modal>
		</Fragment>
	);
};

export default ModalScheduleStarter
